<template>
  <div id="workshop">
    <v-fab-transition>
      <v-btn
        color="primary"
        fab
        large
        dark
        class="v-btn--open-dialog"
        @click="parametersDialog = !parametersDialog"
        style="z-index: 100"
      >
        <v-icon v-if="!parametersDialog">keyboard_arrow_right</v-icon>
        <v-icon v-if="parametersDialog">mdi-close</v-icon>
      </v-btn>
    </v-fab-transition>

    <v-dialog v-model="parametersDialog" max-width="600px">
      <v-card class="mx-auto" max-width="1000">
        <v-card-text>
          <v-form ref="form">
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-domain"
                  v-model="companies"
                  :items="uniqueCompanies"
                  label="Companies"
                  @change="getWorkshops"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  prepend-icon="search"
                  v-model="workshopNames"
                  :items="uniqueWorkshopNames"
                  label="Workshops"
                ></v-select>
              </v-col>
            </v-row>
            <v-row v-if="isAdminRole">
              <v-col cols="12">
                <v-select
                  prepend-icon="mdi-account-multiple"
                  v-model="participants"
                  :items="uniqueParticipants"
                  label="Trainer"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-menu
                  v-model="from"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="fromDate"
                      label="From"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    @input="from = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="6">
                <v-menu
                  v-model="to"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="toDate"
                      label="To"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    @input="to = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <v-card-actions>
              <v-btn
                @click="parametersDialog = !parametersDialog"
                color="red"
                dark
                >Close</v-btn
              >
              <div class="flex-grow-1"></div>
              <v-btn @click="getFeedbackData()" color="info">Update</v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-container style="width: 100%; max-width: 1060px">
      <v-overlay :value="loading">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <p class="text-center display-1 primary--text">Workshop feedback</p>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Companies</v-toolbar-title
              ><a
                class="reset"
                @click="resetFilters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="company-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Trainer</v-toolbar-title
              ><a
                class="reset"
                @click="resetFilters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="trainer-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Rate</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="rate-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Content</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="content-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Understanding</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="understanding-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-4">
          <div class="v-card v-sheet theme--light" style="height: 250px">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Recommend</v-toolbar-title>
              <div class="flex-grow-1"></div>
            </v-toolbar>
            <v-row align="center" justify="center">
              <div id="recommend-chart" class="dc-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text">Workshop</v-toolbar-title
              ><a
                class="reset"
                @click="resetFilters()"
                style="display: true; margin-left: 5px"
                >reset all</a
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center">
              <div id="workshop-chart"></div>
            </v-row>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col col-12">
          <div class="v-card v-sheet theme--light">
            <v-toolbar flat>
              <v-spacer></v-spacer>
              <v-toolbar-title class="black--text"
                >Feedback, Useful Principles & Techniques</v-toolbar-title
              >
              <div class="flex-grow-1"></div>
            </v-toolbar>

            <v-row align="center" justify="center" style="margin: 0 15px">
              <table
                id="feedback-table"
                class="table table-hover dc-data-table"
              >
                <thead>
                  <tr class="header">
                    <th>Feedback</th>
                    <th style="width: 100px">Improvements</th>
                    <th style="width: 100px">Changes</th>
                    <th style="width: 100px">Trainer</th>
                  </tr>
                </thead>
              </table>
            </v-row>
          </div>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { Auth } from "aws-amplify";
import SurveyWorkshop from "../classes/SurveyWorkshop";
import moment from "moment";
export default {
  data: () => ({
    graphData: {},
    loading: false,
    companyChart: null,
    rateChart: null,
    contentChart: null,
    understandingChart: null,
    workshopChart: null,
    workshopChart: null,
    workshopChart: null,
    trainerChart: null,
    feedbackChart: null,
    techniquesTable: null,
    pieLabel: {},
    pieColor: {},
    parametersDialog: false,
    uniqueParticipants: [],
    uniqueCompanies: [],
    uniqueWorkshopNames: [],
    from: false,
    fromDate: null,
    to: false,
    toDate: null,
    participants: "All",
    service: "All",
    companies: "All",
    workshopNames: "All",
  }),
  async mounted() {
    this.loading = true;
    const surveyWorkshop = new SurveyWorkshop(null);
    await surveyWorkshop.getGraphData();
    this.uniqueCompanies = await surveyWorkshop.getUniqueCompanyNames();
    this.uniqueCompanies.unshift("All");

    this.uniqueWorkshopNames.unshift("All");

    this.uniqueParticipants = await surveyWorkshop.getUniqueTrainer();
    this.uniqueParticipants.unshift("All");

    this.pieLabel = {
      0: "F",
      1: "M",
      average: "Avg",
      excellent: "Excel",
      good: "Good",
      poor: "Poor",
      verygood: "V.Good",
      yes: "Yes",
      no: "No",
      dontknow: "Dont Know",
      unsure: "Unsure",
      likely: "Likely",
      extremelylikely: "V.Likely",
      null: "Ignore",
    };
    this.pieColor = {
      excellent: "#B2D732",
      verygood: "#66B032",
      good: "#375F1B",
      average: "#e6550d",
      unsure: "#e6550d",
      poor: "#c62828",
      no: "#c62828",
      yes: "#B2D732",
      dontknow: "#e6550d",
      likely: "#66B032",
      extremelylikely: "#B2D732",
      null: "#e376c2",
    };
    await this.getFeedbackData();
    this.loading = false;
  },
  methods: {
    async getFeedbackData() {
      this.loading = true;

      this.parametersDialog = false;
      let filter = null;
      let query = [];

      if (this.companies && this.companies !== "All") {
        query.push({ company: { contains: this.companies } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.participants && this.participants !== "All") {
        query.push({ participants: { contains: this.participants } });
      }

      if (this.workshopNames && this.workshopNames !== "All") {
        query.push({ name: { contains: this.workshopNames } });
      }

      if (this.fromDate && this.toDate) {
        const from = moment(this.fromDate).toISOString();
        const to = moment(this.toDate).toISOString();
        query.push({
          date: {
            between: [from, to],
          },
        });
      }

      if (!this.isAdminRole) {
        Auth.currentAuthenticatedUser().then((user) => {
          filter = {};
          query.push({ participants: { contains: user.attributes.email } });

          query.forEach((q) => {
            Object.assign(filter, q);
          });
        });
      } else {
        if (query.length > 0) {
          filter = {};
          query.forEach((q) => {
            Object.assign(filter, q);
          });
        }
      }

      const surveyWorkshop = new SurveyWorkshop(filter);
      this.graphData = await surveyWorkshop.getGraphData();
      this.drawCharts();
      this.loading = false;
    },
    async getWorkshops() {
      const surveyWorkshop = new SurveyWorkshop(null);
      await surveyWorkshop.getGraphData();
      this.uniqueWorkshopNames = await surveyWorkshop.getUniqueWorkshopNames(this.companies);
      this.uniqueWorkshopNames.unshift("All");
    },
    drawCharts() {
      var cf = crossfilter(this.graphData);

      // Company Bar Chart
      this.renderCompanyChart(cf);

      // // Quality Pie Chart
      this.renderRateChart(cf);

      // Content Pie Chart
      this.renderContentChart(cf);

      // // Impact Pie Chart
      this.renderUnderstandingChart(cf);

      // Recommend Chart
      this.renderRecommendChart(cf);

      // Workshop Bar Chart
      this.renderWorkshopChart(cf);

      // Trainer Table
      this.renderTrainerChart(cf);

      // Feedback Table
      // this.renderFeedbackTable(cf);

      // Principles & Techniques Table
      this.renderPrinciplesTechniquesTable(cf);

      dc.renderAll();
    },
    renderCompanyChart(cf) {
      const that = this;
      this.companyChart = dc.barChart("#company-chart");
      var companyDimension = cf.dimension(function (d) {
        var ret = d.company === null ? "null" : d.company;
        return ret;
      });
      var companyGrouping = companyDimension.group();
      this.companyChart
        .width(1000)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 120, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("No. Workshops")
        .dimension(companyDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(companyGrouping)
        .on("postRender", function (c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderRateChart(cf) {
      const that = this;
      this.rateChart = dc.pieChart("#rate-chart");
      var rateDimension = cf.dimension(function (d) {
        var ret = d.rateWorkshop === null ? "null" : d.rateWorkshop;
        return ret;
      });
      var rateGrouping = rateDimension.group();
      that.rateChart
        .width(150)
        .height(150)
        .dimension(rateDimension)
        .group(rateGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderContentChart(cf) {
      const that = this;
      this.contentChart = dc.pieChart("#content-chart");
      var contentDimension = cf.dimension(function (d) {
        var ret = d.workshopContent === null ? "null" : d.workshopContent;
        return ret;
      });
      var contentGrouping = contentDimension.group();
      that.contentChart
        .width(150)
        .height(150)
        .dimension(contentDimension)
        .group(contentGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderUnderstandingChart(cf) {
      const that = this;
      this.understandingChart = dc.pieChart("#understanding-chart");
      var understandingDimension = cf.dimension(function (d) {
        var ret =
          d.increaseUnderstanding === null ? "null" : d.increaseUnderstanding;
        return ret;
      });
      var understandingGrouping = understandingDimension.group();
      that.understandingChart
        .width(150)
        .height(150)
        .dimension(understandingDimension)
        .group(understandingGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderRecommendChart(cf) {
      const that = this;
      this.recommendChart = dc.pieChart("#recommend-chart");
      var recommendDimension = cf.dimension(function (d) {
        var ret = d.recommend === null ? "null" : d.recommend;
        return ret;
      });
      var recommendGrouping = recommendDimension.group();
      this.recommendChart
        .width(150)
        .height(150)
        .dimension(recommendDimension)
        .group(recommendGrouping)
        .radius(70)
        .innerRadius(35)
        .label(function (p) {
          return that.pieLabel[p.key];
        })
        .transitionDuration(500)
        .colors(function (d) {
          return that.pieColor[d];
        });
    },
    renderWorkshopChart(cf) {
      const that = this;
      this.workshopChart = dc.barChart("#workshop-chart");
      var workshopDimension = cf.dimension(function (d) {
        var ret = d.workshopName === null ? "null" : d.workshopName;
        return ret;
      });
      var workshopGrouping = workshopDimension.group();
      this.workshopChart
        .width(1000)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 150, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("No. Workshops")
        .dimension(workshopDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(workshopGrouping)
        .on("postRender", function (c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderTrainerChart(cf) {
      const that = this;
      this.trainerChart = dc.barChart("#trainer-chart");
      var trainerDimension = cf.dimension(function (d) {
        var ret = d.trainer === null ? "null" : d.trainer;
        return ret;
      });
      var trainerGrouping = trainerDimension.group();
      this.trainerChart
        .width(1000)
        .height(380)
        .margins({ top: 0, right: 0, bottom: 120, left: 35 })
        .x(d3.scaleBand())
        .xUnits(dc.units.ordinal)
        .brushOn(false)
        //.xAxisLabel('')
        .yAxisLabel("No. Workshops")
        .dimension(trainerDimension)
        .barPadding(0.1)
        .outerPadding(0.05)
        .group(trainerGrouping)
        .on("postRender", function (c) {
          that.adjustBarChartLabels(c);
        });
    },
    renderPrinciplesTechniquesTable(cf) {
      this.techniquesTable = dc.dataTable("#feedback-table");
      var feedbackDimension = cf.dimension(function (d) {
        return d.feedback;
      });

      this.techniquesTable
        .dimension(feedbackDimension)
        .columns([
          "feedback",
          "usefulPrinciplesTechniques",
          "elementsChangeInclude",
          "trainer",
        ])
        .size(100)
        .sortBy(function (d) {
          return d.trainer;
        })
        .order(d3.ascending)
        .on("pretransition", function (table) {
          var body = table.selectAll("tbody");
          body.selectAll("tr").style("display", function (d) {
            // console.log(d,"d");
            if (
              !d.feedback &&
              !d.usefulPrinciplesTechniques &&
              !d.elementsChangeInclude
            ) {
              return "none";
            }
          });
        });
    },
    resetFilters() {
      this.companyChart.filterAll();
      this.rateChart.filterAll();
      this.contentChart.filterAll();
      this.understandingChart.filterAll();
      this.recommendChart.filterAll();
      this.workshopChart.filterAll();
      this.trainerChart.filterAll();
      // this.feedbackTable.filterAll();
      this.techniquesTable.filterAll();
      dc.redrawAll();
    },
    adjustBarChartLabels(chart) {
      chart
        .svg()
        .selectAll(".axis.x text")
        .on("click", function (d) {
          chart.filter(d);
          dc.redrawAll();
          scrollTo(d);
        })
        .style("text-anchor", "end")
        .attr("dx", function (d) {
          return "-0.6em";
        })
        .attr("transform", function (d) {
          return "rotate(-90, -4, 9) ";
        });
    },
  },
  computed: {
    async isAdminRole() {
      const user = await Auth.currentAuthenticatedUser();
      const awsGroups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      if (awsGroups) {
        const roles =
          user.signInUserSession.accessToken.payload["cognito:groups"];
        return roles.includes("ADMIN");
      }
    },
  },
};
</script>
<style>
.dc-table-section {
  display: none !important;
}
.v-btn--open-dialog {
  top: 90px;
  position: fixed;
  margin: 0 0 16px 16px;
}
</style>